import { createApi } from '@reduxjs/toolkit/query/react';

import { createBaseQuery } from '@grafana/api-clients/rtkq';

import { getQueriesAPIBaseURL } from './queriesApiVersionResolver';

export const QUERY_LIBRARY_PAGE_LIMIT = 500;

export const api = createApi({
  reducerPath: 'queriesAPIv1',
  baseQuery: createBaseQuery({
    getBaseURL: getQueriesAPIBaseURL,
  }),
  endpoints: () => ({}),
});
